var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"btn btn-square btn-primary",attrs:{"id":"nextButton","disabled":_vm.isDisabled},on:{"click":_vm.goNext}},[_vm._v(" Next ")])}
var staticRenderFns = []

export { render, staticRenderFns }